export default __webpack_public_path__ + "static/media/exclamation.0ec07464.svg";